export const GET_STAGE = "GET_STAGE";
export const MIGRATE_USER = "MIGRATE_USER";

export const SET_USER_TO_MIGRATE = "SET_USER_TO_MIGRATE";